import React from "react";

import "./stylesKpiCard.css";
import { Skeleton, Statistic } from "antd";
import CountUp from "react-countup";

function KpiCard({
  title,
  value,
  hugeValue,
  percentage,
  rate = false,
  backgroundColor,
  isApiRunning = false,
  customColor = false,
}) {
  const formatter = (value) => (
    <CountUp end={value} separator="," decimal="." decimals={2} />
  );

  return (
    <div id="kpi-card" style={{ backgroundColor }}>
      {isApiRunning && <Skeleton active />}
      {!isApiRunning && (
        <>
          <div className="top">
            <h3>{title}</h3>
          </div>
          <div className="value-container">
            <p
              className={`value ${hugeValue ? "huge-value" : ""}`}
              style={customColor ? { color: customColor } : { color: "white" }}
            >
              {rate ? "" : "$"}{" "}
              <div className="statistic-value">
                <Statistic
                  value={value}
                  formatter={formatter}
                  valueStyle={
                    customColor ? { color: customColor } : { color: "white" }
                  }
                />
              </div>
              {rate ? "%" : ""}
              {/* {rate ? "" : "$"} {value} {rate ? "%" : ""} */}
            </p>
            {percentage && (
              <p>
                {" "}
                <span
                  className="percentage"
                  style={
                    percentage > 0 ? { color: "#71BF8A" } : { color: "#E74C3C" }
                  }
                >
                  {percentage > 0 ? "+ " : " "} {percentage}%
                </span>{" "}
                vs last month
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default KpiCard;
